var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-data-value",class:[_vm.colorData.colorClasses],style:([_vm.colorData.colorStyles])},[_vm._v(" "+_vm._s(_vm._f("splitNumber")(_vm.value))+" "+_vm._s(_vm.unit)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }